import _ from 'underscore';
import { validate, validators } from 'validate.js';

export default class ValidateService {
  ruleMappingList = [];

  constructor(modalService) {
    this.modalService = modalService;
  }

  async pushMsgList() {
    validators.presence.message = '^' + '{0}은(는) 필수 입력 항목입니다.';
    validators.length.tooShort =
      '^' + '{0}은(는) %{count}자 이상 입력해 주십시오';
    validators.length.tooLong =
      '^' + '{0}은(는) %{count}자 이하로 입력해 주십시오';
    validators.numericality.notInteger =
      '^' + '{0}은(는) 정수로 입력해 주십시오';

    validators.numericality.notGreaterThan = validators.date.message =
      '^' + '{0}은(는) %{count}보다 큰 값을 입력해 주십시오';

    validators.numericality.notGreaterThanOrEqualTo = validators.date.message =
      '^' + '{0}은(는) %{count}보다 크거나 같은 값을 입력해 주십시오';

    validators.numericality.notEqualTo = validators.date.message =
      '^' + '{0}은(는) %{count}와(과) 같은 값을 입력해 주십시오';

    validators.numericality.notLessThan = validators.date.message =
      '^' + '{0}은(는) %{count}보다 작은 값을 입력해 주십시오';

    validators.numericality.notLessThanOrEqualTo = validators.date.message =
      '^' + '{0}은(는) %{count}보다 작거나 같은 값을 입력해 주십시오';

    validators.email.message = '^' + '{0}은(는) 이메일 형식에 맞지 않습니다';
  }

  async validateJsCall(datas, rulesParam, altKeyParam) {
    await this.pushMsgList();

    let rules = null;
    let altKey = null;

    if (_.isNull(rulesParam)) {
      rules = _.where(this.ruleMappingList, { model: datas })[0]['rules'];
    } else {
      rules = rulesParam;
    }

    if (!_.isNull(altKeyParam)) {
      altKey = altKeyParam;
    }

    for (const ruleKey of Object.keys(rules)) {
      if (rules[ruleKey]['presence'] === true) {
        rules[ruleKey]['presence'] = { allowEmpty: false };
      }
    }

    //실행
    let errorMessages = validate(datas, rules) || null;

    //errpr 메시지 표시
    if (errorMessages) {
      let msg = [];

      for (let [key, value] of Object.entries(errorMessages)) {
        let newKey = null;

        if (_.isNull(altKey)) {
          newKey = key;
        } else {
          if (_.isNull(altKey[key]) || _.isUndefined(altKey[key])) {
            newKey = key;
          } else {
            newKey = altKey[key];
          }
        }

        let newVal = value[0].replace('{0}', '<b>' + newKey + '</b>');

        msg.push(newVal);
      }

      this.modalService.noticeAlert(msg.toString().replaceAll(',', '<br />'));
    }

    return errorMessages !== null ? true : false;
  }
}
